import createCachedSelector from 're-reselect';

import { isBannerPriceEditable } from '../service/BannerHelpers/BannerHelpers';
import { getEditCellKey } from '../service/GridHelpers/GridHelpers';
import { Banner } from '../typings/domain';
import { State } from '../typings/state';

import { selectGridSourceParams } from './gridSourceParams/gridSourceParams';

export const selectBannersPricesPopup = createCachedSelector(
    (state: State) => selectGridSourceParams(state).view,
    (state: State) => state.grid.editCellsData,
    (state: State, index: number) => state.grid.gridData.data[index] as Banner,
    (view, editCellsData, banner) => {
        const cellKeysFields = {
            id: banner.id,
            column: 'price',
            view
        };

        const key = getEditCellKey(cellKeysFields);

        let errors =
            editCellsData[key] !== undefined ? editCellsData[key].error : [];

        if (!errors || typeof errors === 'string') {
            errors = [];
        }

        const bannerPrice = banner.bannerPrice;
        const isEditable = isBannerPriceEditable(banner);

        return {
            cellKeysFields,
            errors,
            bannerPrice,
            isEditable
        };
    }
)((state: State, index: number): string => index.toString());
